<div class="scrn">
  <div class="abs_center stout">
    <div class="title">
      Select User
    </div>
    <div class="lines">
      <div class="line" *ngFor="let id of users_ids">

        <div class="" (click)="selUser(id)">
          {{_users[id].email}} {{_users[id].first_name}} {{_users[id].last_name}}
          <span *ngIf="_users[id].progress"> Progress: {{_users[id].progress}}%
            <img class="exp" [ngClass]="{colapse:expand_id}" src="assets/images/expand.svg" (click)=toogleExp($event,id)>
          </span>
          <div *ngIf="expand_id == id" class="expand">

            <div *ngFor="let key of expand_tasks_keys" class="task">
              Task {{ _users[expand_id].tasks[key].name}} Progress:{{ _users[expand_id].tasks[key].progress}}
            </div>
          </div>

        </div>
      </div>
    </div>

    <img src="assets/images/close.svg" class="close" kzLib (click)="closeIt()" />
  </div>

</div>
